<template>
  <Attachment ref="attachment" :name="name" :readonly="readonly" :view="view" :value="fileInfo" @change="onChange" @fileChange="fileChange" @emitClear="emitClear" />
</template>
<script>
import Attachment from '@components/Attachment.vue'
import * as estimateManager from '@managers/estimateManager'
// import * as utils from '@libs/utils'
export default {
  components: {
    Attachment
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fileInfo: {
        filename: '',
        url: ''
      }
    }
  },
  watch: {
    value: {
      handler: function(newValue) {
        this.setValue(newValue)
      },
      deep: true
    },
  },
  created() {
    this.setValue(this.value)
  },
  methods: {
    setValue(value) {
      if (value) {
        const filename = value.originalName || ''
        const attachmentUrl = estimateManager.buildAttachmentUrl(value.url, this.$store.getters.user.token)
        if (this.fileInfo.filename !== filename || this.fileInfo.url !== attachmentUrl) {
          this.fileInfo.filename = filename
          this.fileInfo.url = attachmentUrl
        }
      }
    },

    // clear() {
    //   this.fileInfo.filename = ''
    //   this.fileInfo.url = ''
    // },

    onChange(attachment) {
      this.$emit('change', attachment)
    },

    fileChange(file) {
      this.$emit('fileChange', file)
    },

    emitClear() {
      this.$emit('emitClear')
    },

    setFile(file) {
      this.$refs.attachment.setFile(file)
    },

    clear() {
      this.$refs.attachment.refClear()
    }
  }
}
</script>